export const FETCH_INVESTORTRACKING_BEGIN = "FETCH_INVESTORTRACKING_BEGIN";
export const FETCH_INVESTORTRACKING_SUCCESS = "FETCH_INVESTORTRACKING_SUCCESS";
export const FETCH_INVESTORTRACKING_FAILURE = "FETCH_INVESTORTRACKING_FAILURE";

export const FETCH_INVESTORTRACKINGTRANSACTIONTYPE_BEGIN = "FETCH_INVESTORTRACKINGTRANSACTIONTYPE_BEGIN";
export const FETCH_INVESTORTRACKINGTRANSACTIONTYPE_SUCCESS = "FETCH_INVESTORTRACKINGTRANSACTIONTYPE_SUCCESS";
export const FETCH_INVESTORTRACKINGTRANSACTIONTYPE_FAILURE = "FETCH_INVESTORTRACKINGTRANSACTIONTYPE_FAILURE";

export const FETCH_INVESTORTRACKINGPORTFOLIO_BEGIN = "FETCH_INVESTORTRACKINGPORTFOLIO_BEGIN";
export const FETCH_INVESTORTRACKINGPORTFOLIO_SUCCESS = "FETCH_INVESTORTRACKINGPORTFOLIO_SUCCESS";
export const FETCH_INVESTORTRACKINGPORTFOLIO_FAILURE = "FETCH_INVESTORTRACKINGPORTFOLIO_FAILURE";

export const FETCH_INVESTORTRACKINGASSET_BEGIN = "FETCH_INVESTORTRACKINGASSET_BEGIN";
export const FETCH_INVESTORTRACKINGASSET_SUCCESS = "FETCH_INVESTORTRACKINGASSET_SUCCESS";
export const FETCH_INVESTORTRACKINGASSET_FAILURE = "FETCH_INVESTORTRACKINGASSET_FAILURE";

export const FETCH_INVESTORTRACKINGSTATUS_BEGIN = "FETCH_INVESTORTRACKINGSTATUS_BEGIN";
export const FETCH_INVESTORTRACKINGSTATUS_SUCCESS = "FETCH_INVESTORTRACKINGSTATUS_SUCCESS";
export const FETCH_INVESTORTRACKINGSTATUS_FAILURE = "FETCH_INVESTORTRACKINGSTATUS_FAILURE";